<template>
  <v-card>
    <v-card-text>
      <v-row>
      
          <v-col v-for="(field,index) in fields" :key="`fields-left${index}`" cols="4">
            <component
              :is="field.component"
              v-model="doc[field.model]"
              :title="field.title"
              :label="field.title"
              :prefix="field.prefix"
              :props="field.props"
              class="area"
            />
          </v-col>
       
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// const fb = require("@/firebaseConfig.js");

import { UnitTextArea, UnitTextField, UnitTag } from "@/components/units";

export default {
  name: "UserServiceForm",
  data() {
    return {
      doc: this.value,
      fields: [
        {
          title: "Concept",
          count: 1,
          component: UnitTextArea,
          model: "concept",
          color: "red",
          props: {title: "Concept"},
          prefix: "",
        },
        {
          title: "Sentence",
          count: 2,
          component: UnitTextArea,
          model: "sentence",
          props: {title: "Sentence"},
          prefix: "",
        },
        {
          title: "Hashtag",
          count: 3,
          component: UnitTextField,
          model: "hashtag",
          props: {title: "Hashtag"},
          prefix: "#",
        },
        {
          title: "Activations",
          count: 4,
          component: UnitTag,
          model: "channels",
          props: {title: "Activations"},
          prefix: "",
        },
        {
          title: "Engagement",
          count: 5,
          component: UnitTag,
          model: "earned",
          props: {title: "Engagement"},
          prefix: "",
        },
      ]
    };
  },
  components: {
    UnitTextArea,
    UnitTextField,
    UnitTag,
  },
  props: {
    value: Object
  },
  watch: {
    doc: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.doc = val;
    },
  },
};
</script>
